<template lang="pug">
.v-video.video
	template(v-if="isStarted")
		.video__iframe-wrap(v-if="type === 'youtube' && youtubeSrc")
			iframe.video__iframe(ref="ytvideo"
				:src="youtubeSrc"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerpolicy="strict-origin-when-cross-origin"
				allowfullscreen)
		video.video__video(v-else-if="src"
			ref="video"
			controls
			:poster="poster"
			:loop="loop"
			:muted="muted"
			:autoplay="autoplay")
			source.video__source(:src="src" :type="computedType")
	template(v-else)
		template(v-if="type === 'youtube'" )
			img.video__poster(:src="poster" alt="" loading="lazy")
		template(v-else )
			video.video__poster(:src="poster" alt="" loading="lazy")
		button.video__btn(type="button" @click="startVideo")
			v-svg-icon.video__btn-icon(icon="play-btn")
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: 'video/mp4'
		},

		poster: {
			type: String,
			default: null
		},

		src: {
			type: String,
			default: null,
			required: true
		},

		autoplay: {
			type: Boolean,
			default: false
		},

		loop: {
			type: Boolean,
			default: false
		},

		origin: {
			type: String,
			default: null
		},

		muted: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			isStarted: false,
			youtubeSrc: null
		};
	},

	created() {
		this.initVideo();
	},

	methods: {
		initVideo() {
			if (this.type === 'youtube') {
				const url = new URL(this.src);

				let {pathname} = url;

				if(pathname && pathname.indexOf("/embed") === -1) {
					url.pathname = `/embed${pathname}`;
				}

				url.searchParams.set('autoplay', this.autoplay ? '1' : '0');
				url.searchParams.set('mute', this.muted ? '1' : '0');
				url.searchParams.set('loop', this.loop ? '1' : '0');
				if (this.origin) {
					url.searchParams.set('origin', 'https://yourdomain.by');
				}
				url.searchParams.set('playsinline', '1');
				this.youtubeSrc = url.href;

			}
		},

		startVideo() {
			this.isStarted = true;
			this.$nextTick(() => {
				if (this.type === 'youtube') {
					const url = new URL(this.youtubeSrc);
					url.searchParams.set('autoplay', '1');
					this.youtubeSrc = url.href;
				} else {
					this.$refs['video'].play();
				}
			})

		}
	},

	computed: {
		computedType() {
			if(this.type === 'video' && this.src) {
				return `${this.type}/${this.src.substring(this.src.indexOf('.') + 1)}`
			}
		}
	}
};
</script>